import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "../components/Login";
import Dashboard from "../components/AppComponents/Dashboard";
import ContentPage from "../components/AppComponents/Content";
import BroadcastNotification from "../components/AppComponents/BroadcastNotification";
import OfficerList from "../components/AppComponents/Officer";
import OfficerDetail from "../components/AppComponents/OfficerDetail";
import Layout from "../components/Layout";

// New imports for blogs
import Blogs from "../components/AppComponents/Blogs";
import AddBlog from "../components/AppComponents/AddBlog";
import SubscriptionList from "../components/AppComponents/SubscriptionList";
import Operations from "../components/AppComponents/Operations";
import Referrals from "../components/AppComponents/Referrals";

const PrivateRoute = ({ children }) => {
  const userData = useSelector((state) => state.user.userData);
  const isAuthenticated = userData?.token;
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const userData = useSelector((state) => state.user.userData);
  const isAuthenticated = userData?.token;
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
};

export default function Router() {
  const userData = useSelector((state) => state.user.userData);
  const isAuthenticated = userData?.token;

  return (
    <BrowserRouter>
      <Routes>
        {/* Root redirect */}
        <Route
          path="/"
          element={
            <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />
          }
        />

        {/* Wrap all routes in Layout */}
        <Route path="/" element={<Layout />}>
          {/* Public route */}
          <Route
            path="login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          {/* Private routes */}
          <Route
            path="dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="content"
            element={
              <PrivateRoute>
                <ContentPage />
              </PrivateRoute>
            }
          />
          <Route
            path="broadcast-notification"
            element={
              <PrivateRoute>
                <BroadcastNotification />
              </PrivateRoute>
            }
          />
          <Route
            path="officers"
            element={
              <PrivateRoute>
                <OfficerList />
              </PrivateRoute>
            }
          />
          <Route
            path="subscription"
            element={
              <PrivateRoute>
                <SubscriptionList />
              </PrivateRoute>
            }
          />
          <Route
            path="operations"
            element={
              <PrivateRoute>
                <Operations />
              </PrivateRoute>
            }
          />
          <Route
            path="referrals"
            element={
              <PrivateRoute>
                <Referrals />
              </PrivateRoute>
            }
          />
          <Route
            path="officer/:id"
            element={
              <PrivateRoute>
                <OfficerDetail />
              </PrivateRoute>
            }
          />

          {/* Blog routes */}
          <Route
            path="blogs"
            element={
              <PrivateRoute>
                <Blogs />
              </PrivateRoute>
            }
          />
          <Route
            path="add-blog"
            element={
              <PrivateRoute>
                <AddBlog />
              </PrivateRoute>
            }
          />
          <Route
            path="edit-blog/:id"
            element={
              <PrivateRoute>
                <AddBlog />
              </PrivateRoute>
            }
          />

          {/* Catch-all */}
          <Route
            path="*"
            element={
              <Navigate
                to={isAuthenticated ? "/dashboard" : "/login"}
                replace
              />
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
